import { NumberModel } from '@/types';
import BaseService from '@/services/api/BaseService';

class NumberService extends BaseService<NumberModel> {}

export default new NumberService('numbers');
